import React,{Component} from 'react';
import FilterDropDown from './FilterDropDown';

/**
 * This is the part of the searchbar component that displays the filter items and searchbar.
 * 
 * It is a complete re-write of the prior searchbar component, please refer to ACH-328
 * for more details. 
 */
class FilterHeader extends Component{
    constructor(props){
        super(props);
        this.state={
            selected:false,
            sectionID:null,
            selectedFilters:[]
        }
    }

    componentDidMount() {
		document.addEventListener('mousedown',this.handleAllClick,false);
        this.setState({ sectionID: this.props.data.Tag_Type_ID, selectedFilters: this.props.filters });
    }

	componentWillUnmount(){
		document.removeEventListener('mousedown',this.handleAllClick,false);
	}

    componentDidUpdate(prevProps, prevState) {
		let newState={};

		if (prevProps.current !== "" && (prevProps.current !== this.props.current && this.props.current !== this.state.sectionID))
			newState={
				...newState,
				selected:false
			}
		
		if(prevProps.filters!==this.props.filters)
			newState={
				...newState,
				selectedFilters:this.props.filters
			}
		
		if(Object.keys(newState).length>0)
			this.setState(newState);
    }

    handleOnClick(e) {
        this.setState(
            prevState => {
                this.props.current !== "" && this.props.current === this.props.data.Tag_Type_ID && prevState.selected ?
                    this.props.handleOnClick('') : this.props.handleOnClick(this.props.data.Tag_Type_ID);

                return {
                    selected: !prevState.selected
                };

            }
        );
    }

    handleAllClick=(e)=>{
		if (this.node===undefined || this.node.contains(e.target))
			return;

        if (this.state.selected !== false) {
            this.setState(
                prevState => {
                    this.props.current !== "" && this.props.current === this.props.data.Tag_Type_ID && prevState.selected ?
                        this.props.handleOnClick('') : this.props.handleOnClick(this.props.data.Tag_Type_ID);

                    return {
                        selected: !prevState.selected
                    };

                }
            );
        }

    }

    handleItemSelection(e) {
        this.setState(
            prevState => {
                let filters = [];

                filters = prevState.selectedFilters;

                if (filters.includes(e)) {
                    filters.splice(filters.indexOf(e), 1);
                    this.props.onItemDeselect(e);
                }
                else {
                    this.props.onItemSelect(e);
                    filters.push(e);
                }

                return {
                    selectedFilters: filters
                };

            }
        );
    }

    render() {
        return (
            <div ref={node=>this.node=node} tabIndex={0}>
                <div className="category-container" id={this.props.data.Tag_Type_ID} onClick={(e)=>{this.handleOnClick()}}>
                    <div className={['cat-name',this.state.selected?'active':null].join(' ')}>{this.props.data.Name}</div>
                </div>
                <FilterDropDown
					selectedTags={this.state.selectedFilters}
					onItemSelect={this.handleItemSelection.bind(this)}
					Tags={this.props.data.Tags}
					selected={this.state.selected} />
            </div>
        )
    }
}

export default FilterHeader;  